<template>
    <b-alert :show="true" variant="secondary" class="mt-2">
        <h3>
            <font-awesome-icon icon="info-circle"></font-awesome-icon>
            Hello,
            {{ user.person.first_name }} {{ user.person.last_name }},
            Welcome back!
        </h3>
    </b-alert>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState(["user"])
}
</script>